import { formatDate, formatTime } from './format';

export const maskTemplates = {
  cep: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);

    if (value.indexOf('.') >= 0 && value.indexOf(',') < 0) value = value.replace('.', ',');

    value = value.replace(/\D/g, '');
    value = value.replace(/^(\d{5})(\d)/, '$1-$2');
    return value;
  },
  currency: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);
    value = value.replace('.', '').replace(',', '').replace(/\D/g, '');

    const options = { minimumFractionDigits: 2 };
    const result = new Intl.NumberFormat('pt-BR', options).format(parseFloat(value) / 100);

    return 'R$ ' + result;
  },
  percent: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);
    value = value.replace('.', '').replace(',', '').replace(/\D/g, '');

    const options = { minimumFractionDigits: 2 };
    const result = new Intl.NumberFormat('pt-BR', options).format(parseFloat(value) / 100);

    return '% ' + result;
  },
  integer: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);
    value = value.replace(/\D/g, '');
    return value;
  },
  decimal: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d)(\d{2})$/, '$1,$2');
    value = value.replace(/(?=(\d{3})+(\D))\B/g, '.');
    return value;
  },
  cpf: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);
    if (!value.match(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})$/)) {
      value = value.replace(/\D/g, '');
      value = value.substr(0, 11);
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d{2})$/, '$1-$2');
    }
    return value;
  },
  cnpj: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);
    if (!value.match(/^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})$/)) {
      value = value.replace(/\D/g, '');
      value = value.substr(0, 14);
      value = value.replace(/(\d{2})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d)/, '$1/$2');
      value = value.replace(/(\d{4})(\d{2})$/, '$1-$2');
    }
    return value;
  },
  cpf_cnpj: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);
    value = value.replace(/\D/g, '');
    return maskTemplates[value.length <= 11 ? 'cpf' : 'cnpj'](value);
  },
  phone: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);

    const numeros = value.replace(/\D/g, '');

    // Formatar o número no padrão desejado
    const codigoPais = numeros.substring(0, 2);
    const codigoArea = numeros.substring(2, 4);
    const primeiroBloco = numeros.substring(4, 9);
    const segundoBloco = numeros.substring(9);

    return `${codigoPais} (${codigoArea}) ${primeiroBloco}-${segundoBloco}`;
  },
  phone_without_country: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);

    const numeros = value.replace(/\D/g, '');

    // Formatar o número no padrão desejado
    const codigoArea = numeros.substring(0, 2);
    const primeiroBloco = numeros.substring(2, 7);
    const segundoBloco = numeros.substring(7);

    if (!codigoArea?.length) return '';

    return `(${codigoArea}) ${primeiroBloco}-${segundoBloco}`;
  },
  date: (value: any | Date): string => {
    if (value instanceof Date) return formatDate(value);

    value = String(value);
    if (typeof value !== 'string') return String(value);
    return value
      .replace(/\D/g, '')
      .substring(0, 8)
      .replace(/(\d{2})(\d)/, '$1/$2')
      .replace(/(\d{2})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d)/, '$1');
  },
  time: (value: any | Date): string => {
    if (value instanceof Date) return formatTime(value);

    value = String(value);
    if (typeof value !== 'string') return String(value);
    return value
      .replace(/\D/g, '')
      .substring(0, 6)
      .replace(/(\d{2})(\d)/, '$1:$2')
      .replace(/(\d{2})(\d)/, '$1:$2')
      .replace(/(\d{2})(\d)/, '$1');
  },
  datetime: (value: any | Date, separator = ' ') => {
    if (value instanceof Date) return `${formatDate(value)}${separator}${formatTime(value)}`;

    value = String(value);
    if (typeof value !== 'string') return String(value);
    return value
      .replace(/\D/g, '')
      .substring(0, 14)
      .replace(/^(\d{2})(\d)/, '$1/$2')
      .replace(/^(\d{2}\/\d{2})(\d)/, '$1/$2')
      .replace(/^(\d{2}\/\d{2}\/\d{4})(\d)/, `$1${separator}$2`)
      .replace(/^(\d{2}\/\d{2}\/\d{4} \d{2})(\d)/, '$1:$2')
      .replace(/^(\d{2}\/\d{2}\/\d{4} \d{2}:\d{2})(\d)/, '$1:$2');
  },
  boleto: (value: any): string => {
    value = String(value);
    if (typeof value !== 'string') return String(value);
    value = value.replace(/\D/g, '');
    let result = String(value);

    if (value.length > 5) result = value.substring(0, 5) + '.' + value.substring(5, 10);
    if (value.length > 10) result += ' ' + value.substring(10, 15);
    if (value.length > 15) result += '.' + value.substring(15, 21);
    if (value.length > 21) result += ' ' + value.substring(21, 26);
    if (value.length > 26) result += '.' + value.substring(26, 32);
    if (value.length > 32) result += ' ' + value.substring(32, 33);
    if (value.length > 33) result += ' ' + value.substring(33, 48);

    return result;
  },
};

export const maskOnlyLetters = (value: string) => {
  return value.replace(/[0-9!@#¨$%^&*)(+=._-]+/g, '');
};

export const maskOnlyNumbers = (value: string) => {
  return value.replace(/\D/g, '');
};

export const maskRemoveCurrency = (value: string): string => {
  if (typeof value !== 'string') return value;
  value = maskTemplates.currency(value) as string;
  return (
    value
      .replaceAll('.', '')
      // .replaceAll(',', '.')
      .replace(/[^0-9.]/g, '') || '0'
  );
};

export const maskRemove = (value: string): string => {
  return maskOnlyNumbers(value);
};

export const BRReal = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});
